import BaseService from './base-service.js'

const baseUrlProducts = '/products/mer'
const baseUrlStore = '/stores/bo'

export default {
    async getBaseProducts() {
        const { data } = await BaseService.get(
            `${baseUrlProducts}/baseProducts`
        )
        return data
    },

    async getProducts(option) {
        const { data } = await BaseService.get(`${baseUrlProducts}/products`, {
            params: option,
        })
        return data
    },

    async getMerchants() {
        const { data } = await BaseService.get(`${baseUrlStore}/merchants`)
        return data
    },

    async getProductsById({ id }) {
        const { data } = await BaseService.get(
            `${baseUrlProducts}/product/${id}`
        )
        return data
    },

    async addMerchantProduct(product) {
        const { data } = await BaseService.post(
            `${baseUrlProducts}/product`,
            product
        )
        return data
    },

    async updateProduct(id, product) {
        const { data } = await BaseService.put(
            `${baseUrlProducts}/product/${id}`,
            product
        )
        return data
    },

    async deleteProduct(id) {
        const { data } = await BaseService.delete(
            `${baseUrlProducts}/product/${id}`
        )
        return data
    },
}
